import { Link } from 'react-router-dom';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { TrendChart } from './TrendChart';
import { carrierWeekly } from '@/data/carrierStats';
import { getCarrier } from '@/data/arrivalsData';
import { t } from '@/i18n';
import { FileText } from 'lucide-react';

// Weekly evolution of one carrier: no-shows and on-time arrivals.
export const CarrierDetailSheet = ({ carrierId, onClose }) => {
  if (!carrierId) return null;
  const carrier = getCarrier(carrierId);
  const weeks = carrierWeekly(carrierId);
  const pilotWeek = weeks.find(w => w.pilot);

  return (
    <Sheet open onOpenChange={(open) => !open && onClose()}>
      <SheetContent className="sm:max-w-xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle>{carrier.name}</SheetTitle>
          <div className="text-sm text-muted-foreground">
            {carrier.dispatcher.name} · {carrier.dispatcher.phone} · {carrier.fleet} {t('stats.carrier.trucks')}
          </div>
        </SheetHeader>
        <div className="mt-6 space-y-4">
          <TrendChart
            title={t('stats.carrier.weeklyNoShows')}
            rows={weeks}
            unit=" %"
            pilotDate={pilotWeek?.date}
            series={[{ key: 'noShowPct', name: t('stats.carrier.noShowPct'), color: 'hsl(var(--destructive))', type: 'bar' }]}
          />
          <TrendChart
            title={t('stats.carrier.weeklyOnTime')}
            rows={weeks}
            unit=" %"
            pilotDate={pilotWeek?.date}
            series={[{ key: 'onTimePct', name: t('stats.carrier.onTimePct'), color: 'hsl(var(--chart-1))' }]}
          />
          <p className="text-xs text-muted-foreground">{t('stats.carrier.detailHint')}</p>
          <Button variant="outline" size="sm" className="gap-1" asChild>
            <Link to={`/statistiky/dopravci/${carrierId}`}><FileText className="h-4 w-4" /> {t('rating.open')}</Link>
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
